import React, { useState } from 'react';
import './courseCertificate.css'

function C2wCourseCertificate() {

    return (
        <div className='C2wCourseCertificate_ctn'>
            <div className='C2wCourseCertificate_card'>
                <div className='C2wCourseCertificate_card_certificateHolder'>
                    <img src='/assets/images/courseDetails/Certifiacte.png' alt='/'/>
                    {/* <div className='CertificateView'>
                        <svg width="39" height="39" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M34.1246 34.125L26.8349 26.8223M17.0621 11.375V17.0625M17.0621 17.0625V22.75M17.0621 17.0625H22.7496M17.0621 17.0625H11.3746M30.8746 17.0625C30.8746 20.7258 29.4194 24.2391 26.829 26.8294C24.2387 29.4198 20.7254 30.875 17.0621 30.875C13.3988 30.875 9.88557 29.4198 7.29522 26.8294C4.70488 24.2391 3.24963 20.7258 3.24963 17.0625C3.24963 13.3992 4.70488 9.88593 7.29522 7.29559C9.88557 4.70524 13.3988 3.25 17.0621 3.25C20.7254 3.25 24.2387 4.70524 26.829 7.29559C29.4194 9.88593 30.8746 13.3992 30.8746 17.0625Z" stroke="white" stroke-width="3.25" stroke-linecap="round" />
                        </svg>

                        {'View Certificate'}
                    </div> */}
                </div>

                <div className='C2wCourseCertificate_card_text'>
                    <div className='C2wCoureseDetailComponentHeading_ctn'>
                        <div className='heading'>
                            <span className='headingSpan'>{`${'Get a certificate '}`}</span>
                            {`${'after completing the course'} `}
                        </div>
                    </div>
                    <p>{'Showcase your skills – get a certificate upon completion.'}</p>
                </div>
            </div>
        </div>
    )
}

export default C2wCourseCertificate
